import { BaseEntity } from './../base-models/base-entity';
import { QueryParameter } from './../base-models/query-parameter';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, switchMap, finalize, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class BaseDataService {

  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService,
    protected loaderService: LoaderService
  ) { }

  private unsubscribe$ = new Subject<void>(); // Dodaj ovo u servis ili komponentu
  data: BaseEntity[] = [];

   Get<T extends BaseEntity>(modelName: string, getName: string, parameters: QueryParameter[], modelClass: new() => T, routeParameters: boolean = false): Observable<T[]>{
     return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
     return this.httpClient
       .get(config + 'api/' + modelName + '/' + getName + (!routeParameters ? (new QueryParameter()).GetParametersString(parameters) : (new QueryParameter()).GetParametersRouteString(parameters)))
         .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map((data: any) => {
          //   let items;
          //  if(data instanceof Array){
          //     items = data ? data.map(item => {
          //       return (new BaseEntity()).GetInstance(modelClass).Deserialize(item);
          //     }) : [];
          //     return items;
          //   }
          //   else if(data instanceof Object){
          //     return (new BaseEntity()).GetInstance(modelClass).Deserialize(data);
          //     }
          //   else {
          //     return data;
          //   }
            if (Array.isArray(data)) {
              return data.map(item => new modelClass().Deserialize(item)); // ✅ Ispravljeno!
            } else if (typeof data === 'object' && data !== null) {
              return new modelClass().Deserialize(data); // ✅ Bez suvišne `BaseEntity` instance
            } else {
              return data;
            }
          })
        );
      }))
   }

   GetByID<T extends BaseEntity>(modelName: string, ID: number, modelClass: new() => T): Observable<T>{
     return this.httpClient
       .get(this.configService.GetApiUrl() + 'api/' + modelName + '/get/' + ID)
         .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          //map((data: any) => {
          //  const item: T = (new BaseEntity()).GetInstance(modelClass).Deserialize(data) as T;
          //  return item;
         //})
                   map((data: any) => new modelClass().Deserialize(data)) // ✅ Direktno kreiranje instance modela
         )
   }

   GetFile(modelName: string, printName: string, parameters, vratiBlob:boolean = true){
     return this.httpClient
      .post(this.configService.GetApiUrl() + 'api/' + modelName + '/' + printName, parameters, { responseType: 'arraybuffer', observe: 'response'})
        .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map((data: any) => {
          let file = vratiBlob ? new Blob([data.body], { type: data.headers.get('content-type') }) : data;
          return file;
        }))
   }

   Post<T extends BaseEntity>(modelName: string, getName: string, parameters: any, modelClass: new() => T, getParameter: QueryParameter = null, options = null): Observable<T[]>{
     return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
        return this.httpClient
          .post(config + 'api/' + modelName + '/' + getName + ((getParameter) ? ('?' + getParameter.Name + '=' + getParameter.Value) : ''), parameters, options != null ? options : {})
            .pipe(
              takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
              map((data: any) => {
              if(modelClass && typeof(data) != 'number' && Array.isArray(data)//&& typeof(data) != 'object'
              ){
                // const items = data ? data.map(item => {
                //   return (new BaseEntity()).GetInstance(modelClass).Deserialize(item);
                // }) : [];
                // return items;
                return data.map(item => new modelClass().Deserialize(item)); // ✅ Ispravljeno!
              }
              else{
                return data;
              }
            })
            )
        }))
    }

   Save<T extends BaseEntity>(modelName: string, item: T, modelClass: new() => T, shortModelClass: new() => T): Observable<T>{
     if(item.ID == -1 || item.ID == null)
      return this.insert<T>(modelName, item, modelClass, shortModelClass);
    else if(item.ID > 0)
      return this.update<T>(modelName, item, modelClass, shortModelClass);
   }

   private insert<T extends BaseEntity>(modelName: string, item: T, modelClass: new() => T, shortModelClass: new() => T): Observable<T>{
    //  let serializedItem = (new BaseEntity()).GetInstance(modelClass).Serialize(item);
    let serializedItem = new modelClass().Serialize(item);
     this.loaderService.ShowLoader();
     return this.httpClient
      .post<T>(this.configService.GetApiUrl() + 'api/' + modelName + '/POST', serializedItem)
        .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map((data: any) => {
          // const item: T = (new BaseEntity()).GetInstance(shortModelClass).Deserialize(data) as T;
          const item: T = new shortModelClass().Deserialize(data) as T;
          return item;
        }),
          finalize(() => {
              setTimeout(() => {
                  this.loaderService.HideLoader();
                }, 300);
          }))
   }

   private update<T extends BaseEntity>(modelName: string, item: T, modelClass: new() => T, shortModelClass: new() => T): Observable<T>{
     this.loaderService.ShowLoader();
     return this.httpClient
      .put<T>(this.configService.GetApiUrl() + 'api/' + modelName + '/PUT/' + item.ID,
      //  (new BaseEntity()).GetInstance(modelClass).Serialize(item)
      new modelClass().Serialize(item)
          )
        .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map((data: any) =>{
          // const item: T = (new BaseEntity()).GetInstance(shortModelClass).Deserialize(data) as T;
          const item: T = new shortModelClass().Deserialize(data) as T;
          return item;
        }),
          finalize(() => {
              setTimeout(() => {
                  this.loaderService.HideLoader();
                }, 300);
          }))
   }

   Delete(modelName: string, ID: number){
     this.loaderService.ShowLoader();
     return this.httpClient
      .delete(this.configService.GetApiUrl() + 'api/' + modelName + '/DELETE/' + ID)
        .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map((data: any) => {
          this.loaderService.HideLoader();
          return data;
        }),
          finalize(() => {
            this.loaderService.HideLoader();
          }))
   }

   DeleteItem<T extends BaseEntity>(modelName: string, item: T){
     return this.Delete(modelName, item.ID);
   }

   GetData(modelName: string, getName: string, parameters){
     return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
     return this.httpClient
      .post(config + 'api/' + modelName + '/' + getName, parameters)
        .pipe(
          takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
          map(data => {
          return data;
        }))
      }))
   }

   ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

   LockUnLock<T extends BaseEntity>(modelName: string, item: T, modelClass: new() => T): Observable<T>{
      // let serializedItem = (new BaseEntity()).GetInstance(modelClass).Serialize(item);
      let serializedItem = new modelClass().Serialize(item);
      let nameOfMethod = item.Useridlk ? '/UnLock' : '/Lock';
      return this.httpClient
      .post<T>(this.configService.GetApiUrl() + 'api/' + modelName + nameOfMethod, serializedItem)
          .pipe(
            takeUntil(this.unsubscribe$), // ✅ Otkazuje Observable ako komponenta nestane
            map((data: any) => {
            // const item: T = (new BaseEntity()).GetInstance(modelClass).Deserialize(data) as T;
            const item: T = new modelClass().Deserialize(data) as T;
            return item;
          }),
          )
   }
   
}
